import { useEffect, useMemo, useState } from 'react';
import ApiDatabase from 'server';

/**
 * Hook partagé pour la logique de sélection de motif de désattribution.
 *
 * @param {string|null} idMission   - ID Mongo de la mission (null = pas de fetch)
 * @param {string[]} [onlyNames]  - Si fourni, ne garde que les motifs dont le `name` est dans cette liste
 */
export default function useUnassignReasons(idMission, onlyNames = null) {
  const [reasons, setReasons] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [subReasonsSelected, setSubReasonsSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isMissionStarted, setIsMissionStarted] = useState(false);

  useEffect(() => {
    if (!idMission) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    ApiDatabase.getReasonUnassignMission(
      { idMission },
      (data) => {
        let result = data?.reasons || data || [];
        if (onlyNames) {
          result = result.filter((r) => onlyNames.includes(r.name));
        }
        setReasons(result);

        if (data?.missionDateStart) {
          const today = new Date();
          const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
          const startStr = data.missionDateStart.slice(0, 10);
          setIsMissionStarted(todayStr >= startStr);
        }

        setIsLoading(false);
      },
      () => setIsLoading(false)
    );
  }, [idMission, onlyNames]);

  useEffect(() => {
    setSubReasonsSelected([]);
  }, [selectedId]);

  const selectedReason = useMemo(
    () => reasons.find((r) => r._id === selectedId),
    [selectedId, reasons]
  );

  const isNoShow = selectedReason?.name?.toLowerCase() === 'no-show';

  const noShowError =
    isNoShow && !isMissionStarted
      ? 'Le motif "No-show" ne peut être sélectionné qu\'une fois la mission commencée'
      : '';

  const hasSubReasons = selectedReason?.subReasons?.length > 0;

  const handleSubReasonsChange = (updatedList) => {
    setSubReasonsSelected(updatedList.filter((i) => i.checked).map((i) => i.value));
  };

  const reset = () => {
    setSelectedId('');
    setSubReasonsSelected([]);
  };

  return {
    reasons,
    selectedId,
    setSelectedId,
    selectedReason,
    hasSubReasons,
    subReasonsSelected,
    handleSubReasonsChange,
    isLoading,
    isNoShow,
    noShowError,
    reset,
  };
}
